import React from 'react';

import Title from '../../components/Title';
import Spreader from '../../components/Spreader';
import Paragraph from '../../components/Paragraph';
import Quote from '../../components/Quote';

import QuoteNoPhoto from '../../components/QuoteNoPhoto';
import Sticker from '../../components/Sticker';
import Menu from '../../components/Menu';
import Grid from '../../components/Grid';
import Banner from '../../components/Banner';
import Mention from '../../components/Mention';
import Scalable from '../../components/Scalable';
import CallToAction from '../../components/CallToAction';

import { StickyContainer } from 'react-sticky';

const MatchpointPage = props => (
  <StickyContainer>
    <Menu active="matchpoint" />
    <Spreader>
      <Title text="Стремление вверх" />
      <Paragraph>
        Современный мегаполис немыслим без высотных зданий. И&nbsp;дело даже
        не&nbsp;в&nbsp;том, что вертикально можно построить больше метров
        на&nbsp;небольшом участке земли. Высотное строительство&nbsp;&mdash; это
        амбиции. И&nbsp;в&nbsp;первую очередь амбиции тех, кто выбирает жизнь
        на&nbsp;высоте.
      </Paragraph>
    </Spreader>

    <Spreader>
      Амбиции есть и&nbsp;у&nbsp;самого города. &laquo;Высотная
      доминанта&nbsp;&mdash; актуальный современный тренд: городу сейчас
      необходимы новые высотные доминанты и&nbsp;новые
      силуэты&raquo;,&nbsp;&mdash; считает главный архитектор Москвы Сергей
      Кузнецов.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Московские высотки 50-х&nbsp;&mdash; символы победы довольно долгое время
      оставались единственными высотными доминантами города. Жить в&nbsp;таком
      доме, смотреть на&nbsp;города с&nbsp;высоты было привилегией. Почти через
      полвека новый статус шагающего в&nbsp;ногу с&nbsp;веком мегаполиса
      потребовал строительства &laquo;Москва-Сити&raquo;, символизирующего
      взгляд в&nbsp;будущее, энергию, силу, динамику города, который никогда
      не&nbsp;спит. И&nbsp;вновь&nbsp;&mdash; работать и&nbsp;жить
      на&nbsp;высоте&nbsp;&mdash; привилегия.
    </Spreader>
    <Spreader style={{ 'text-align': 'center' }}>
      <br />
      <b>Точки развития</b>
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Новые городские вертикали возникают и&nbsp;в&nbsp;других
      местах&nbsp;&mdash; точках развития, где очевидно, что будущие жители
      готовы смотреть на&nbsp;город с&nbsp;высоты. Одно из&nbsp;таких
      мест&nbsp;&mdash; Кутузовский проспект. Кутузовский изначально строился
      как проспект &laquo;не&nbsp;для всех&raquo;&nbsp;&mdash; солидный
      и&nbsp;немного сонный. Новое поколение ценность буржуазности признает,
      но&nbsp;все&nbsp;же хочет жить по-новому.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Увы, выбор возможностей пока ограничен. Одна из&nbsp;немногих&nbsp;&mdash;
      проект Match Point&nbsp;&mdash; молодая кровь Кутузовского проспекта
      (fee-девелопер проекта&nbsp;&mdash; &laquo;Галс-Девелопмент&raquo;,
      генеральный подрядчик&nbsp;&mdash; ФОДД, финансовый партнер&nbsp;&mdash;
      ВТБ).
    </Spreader>
    <Spreader isDisappear>
      <iframe
        width="100%"
        height="400"
        src="https://www.youtube.com/embed/gF3ysEDkM68"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      />
    </Spreader>

    <Spreader style={{ 'text-align': 'center' }}>
      <br />
      <b>Все возрасты покорны</b>
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Как подтверждает статистика и&nbsp;динамика продаж&nbsp;&mdash; комплекс
      точно попадает в&nbsp;запросы экономически активной аудитории, причем вне
      зависимости от&nbsp;возраста. Опросы, регулярно проводимые отделом продаж,
      позволили составить список сильных сторон комплекса.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Первую строку занимает, конечно, местоположение&nbsp;&mdash; престижный
      Кутузовский с&nbsp;его инфраструктурными возможностями, близость парков,
      легкий путь до&nbsp;центра города, но&nbsp;особенно отмечается
      потенциальными покупателями близость Сити. Даже если человек там
      не&nbsp;работает, сам факт близости к&nbsp;финансовому центру города
      заставляет поворачивать голову в&nbsp;сторону блестящих башен.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Вторая главная причина, по&nbsp;которой покупатели приходят в&nbsp;офис
      продаж&nbsp;&mdash; проект. Молодые и&nbsp;амбициозные хорошо понимают,
      что архитектура во&nbsp;многом определяет характер человека. В&nbsp;случае
      с&nbsp;Match Point характер будущих жителей можно описать
      фразой&nbsp;&mdash; &laquo;стремление вверх&raquo;. Уверенные в&nbsp;себе,
      взирающие на&nbsp;город как на&nbsp;равного, вступающие с&nbsp;ним
      в&nbsp;деловые и&nbsp;дружеские отношения.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Архитекторы из&nbsp;бюро АБВ сумели совместить несовместимое&nbsp;&mdash;
      одновременно создать &laquo;старомосковскую&raquo; атмосферу
      на&nbsp;улице, и&nbsp;здание&nbsp;&mdash; ракету, устремленное
      в&nbsp;будущее. Удалось это за&nbsp;счет выверенных фасадных решений. Низ
      здания, как раз примерно до&nbsp;уровня, который способен воспринимать
      глаз человека, идущего по&nbsp;улице, отделан юрским мрамором&nbsp;&mdash;
      теплым материалом, приглашающим зайти в&nbsp;магазин или в&nbsp;кафе,
      выпить чашку кофе за&nbsp;столиком. Верх здания отделан легким металлом,
      заставляющим поднять глаза к&nbsp;небу и&nbsp;задуматься
      об&nbsp;изобретении звездолета новой конструкции или нового Фейсбука.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Разнообразным бизнес-интересам покупателей соответствует
      и&nbsp;квартирография&nbsp;&mdash; в&nbsp;комплексе среди 1545
      апартаментов есть любые варианты&nbsp;&mdash; от&nbsp;студий в&nbsp;28
      кв.м. до&nbsp;185&nbsp;&mdash; метровых апартаментов с&nbsp;лоджиями.
      Причем возможно объединение площадей на&nbsp;одном этаже. У&nbsp;всех
      помещений, вне зависимости от&nbsp;корпуса и&nbsp;этажа, приятный вид
      из&nbsp;окон&nbsp;&mdash; на&nbsp;зеленые Фили, Поклонную гору
      и&nbsp;парк, Сити. Конечно, особенно удачны виды с&nbsp;верхних этажей,
      откуда открывается панорама города на&nbsp;много километров.
    </Spreader>

    <Spreader isDisappear>
      <Scalable style={{ marginBottom: '1.5%' }}>
        <img width="100%" src={'images/media/grid_t3_1.jpg'} />
      </Scalable>
    </Spreader>
    <Spreader isWide>
      <Sticker>
        <Quote
          author={{
            photo: 'images/media/kuznetsov.jpg',
            position: 'Главный архитектор Москвы ',

            fullName: 'Сергей Кузнецов',
          }}
          text="Высотная доминанта – актуальный современный тренд: городу сейчас необходимы новые высотные доминанты и новые силуэты"
        />
      </Sticker>
    </Spreader>
    <Spreader isDisappear style={{ marginBottom: '40px' }}>
      <Grid
        fullWidth={3}
        blocks={[
          {
            width: 2,
            content: (
              <Scalable>
                <img src="images/media/grid_t3_2.jpg" width="100%" />
              </Scalable>
            ),
          },
          {
            width: 1,
            content: (
              <Scalable
                style={{ marginBottom: '5%', marginLeft: '5%', width: '95%' }}
              >
                <img src="images/media/grid_t3_3.jpg" width="100%" />
              </Scalable>
            ),
          },
          {
            width: 1,
            content: (
              <Scalable style={{ marginLeft: '5%' }}>
                <img src="images/media/grid_t3_4.jpg" width="100%" />
              </Scalable>
            ),
          },
        ]}
      />
      <Mention>
        На фото: Квартал{' '}
        <a
          href="https://matchpointhouse.ru/?utm_source=kommersant&utm_medium=Cpec_project&utm_campaign=hals"
          target="_blank"
        >
          «Матч Поинт»
        </a>
      </Mention>
    </Spreader>

    <Spreader style={{ 'text-align': 'center' }}>
      <br />
      <b>Свой для своих</b>
    </Spreader>

    <Spreader style={{ marginBottom: '10px' }}>
      Третий важный фактор выбора&nbsp;&mdash; среда. По&nbsp;замыслу авторов
      проекта, которые хорошо понимают покупатели, в&nbsp;комплексе будет свой
      &laquo;клуб равных&raquo;. Людей будет объединять не&nbsp;только общий
      адрес, но&nbsp;и&nbsp;общие интересы. Для этого в&nbsp;Match Point
      запланирован закрытый двор&nbsp;&mdash; внутреннее общественное
      пространство, где помимо традиционных игровых площадок для детей разных
      возрастов, появится воркаут для взрослых, места для встреч и&nbsp;бесед.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Немаловажно и&nbsp;то, что в&nbsp;проект верят и&nbsp;в&nbsp;такой
      структуре как ДОМ.РФ&nbsp;&mdash; один из&nbsp;корпусов был выкуплен
      Агентством под арендное жилье, а&nbsp;с&nbsp;учетом, что такое жилье
      сдается по&nbsp;цене выше рынка, а&nbsp;к&nbsp;управляющей компании
      предъявляются особые требования, то&nbsp;ценность комплекса от&nbsp;такого
      соседства многократно возрастает.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      На&nbsp;сегодняшний день раскуплено уже более 60% комплекса. И&nbsp;меньше клиентов в&nbsp;офисе продаж
      не&nbsp;становится, особенно с&nbsp;учетом того, что до&nbsp;конца декабря
      действуют предновогодние скидки в&nbsp;19%.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Сейчас
      стоимость минимального лота начинается
      от&nbsp;6,8&nbsp;млн&nbsp;руб. В&nbsp;экономику, правда может вмешаться
      макроэкономика, а&nbsp;точнее&nbsp;&mdash; поднятая ЦБ&nbsp;ключевая
      ставка, но&nbsp;если с&nbsp;ценами и&nbsp;ипотечными ставками что
      и&nbsp;произойдет, то&nbsp;не&nbsp;раньше середины января следующего года.
      Хотя звоночек тревожный и&nbsp;повод задуматься о&nbsp;походе в&nbsp;офис
      продаж, даже несмотря на&nbsp;то, что Минфин и&nbsp;ДОМ.РФ обещают
      субсидировать ипотеку в&nbsp;случае негативных изменений. Сегодня&nbsp;же
      финансовые условия покупки крайне привлекательны: при приобретении
      апартамента в&nbsp;ипотеку первоначальный взнос составляет всего 10%. При
      рассрочке&nbsp;&mdash; 30%. Проект работает с&nbsp;разными банками. Одна
      из&nbsp;самых выгодных ставок, разумеется, у&nbsp;финансового
      партнера&nbsp;&mdash; банка ВТБ: 6,1% годовых.
    </Spreader>

    <Spreader isDisappear style={{ marginBottom: '40px' }}>
      <Scalable>
        <Banner
          text="За детальной информацией переходите на сайт  hals&#8209;development.ru"
          linkTitle="Перейти на сайт сейчас"
          link="https://hals-development.ru/?utm_source=kommersant&utm_medium=Cpec_project&utm_campaign=hals"
          bannerBackground="images/banner-bg.png"
        />
      </Scalable>
    </Spreader>
    <Spreader style={{ 'text-align': 'center' }}>
      <br />
      <b>Место для машин</b>
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Несмотря на&nbsp;то, что город стремится к деавтомобилизации, владение
      автомобилем остается признаком достатка и&nbsp;успеха. Хотя, не&nbsp;очень
      понятно, как деавтомобилизация должна способствовать развитию
      внутреннего, в&nbsp;том числе, автотуризма. Но&nbsp;пока эти
      противоречия разрешаются, вопрос дома для автодруга остается актуальным.
      Для жителей Match Point это вопрос решен еще на&nbsp;этапе
      проектирования&nbsp;&mdash; в&nbsp;комплексе большая парковка&nbsp;&mdash;
      1602&nbsp;машино-места, больше, чем одно место на&nbsp;один
      апартамент&nbsp;&mdash; щедрое и&nbsp;ответственное решение застройщика.
      В&nbsp;продажу машино-места выйдут чуть позже, но&nbsp;сегодня уже
      известно, что их&nbsp;ориентировочная стоимость будет
      1,7&ndash;1,8&nbsp;млн в&nbsp;зависимости от&nbsp;его размера
      и&nbsp;местоположения на&nbsp;парковке. Скоро выйдут в&nbsp;продажу
      и&nbsp;коммерческие помещения. В&nbsp;каждой половине комплекса
      на&nbsp;первых этажах запанировано по&nbsp;шесть-семь стометровых
      помещений с&nbsp;высотой потолка 5&nbsp;м. К&nbsp;ним также уже есть
      большой интерес со&nbsp;стороны бизнеса и&nbsp;в&nbsp;том числе, среди
      покупателей апартаментов.
    </Spreader>

    <Spreader style={{ 'text-align': 'center' }}>
      <br />
      <b>Вокруг да около</b>
    </Spreader>

    <Spreader style={{ marginBottom: '10px' }}>
      Надо отметить, что большой интерес к&nbsp;комплексу проявляют жители
      окрестностей. Зеленый тихий престижный район Филей&nbsp;&mdash; приятное
      место для жизни, и&nbsp;многие хотели&nbsp;бы жить здесь и&nbsp;дальше,
      но&nbsp;поменяв свое жилье на&nbsp;более современное, разъехаться
      с&nbsp;родителями, или отселить детей, не&nbsp;меняя при этом района.
      Особенно важно это для тех, у&nbsp;кого дети ходят в&nbsp;детские сады
      и&nbsp;школы. Последних в&nbsp;районе много и&nbsp;они на&nbsp;хорошем
      счету.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Приятна и&nbsp;досуговая инфраструктура&nbsp;&mdash; несколько парков,
      спортивные сооружения, стадионы. У&nbsp;будущих жителей будет
      и&nbsp;особое преимущество&nbsp;&mdash; домашняя волейбольная арена,
      которая строится в&nbsp;составе комплекса. Помимо волейбола в&nbsp;здании
      будут и&nbsp;другие спортивные и&nbsp;оздоровительные опции&nbsp;&mdash;
      спа-зона, банный комплекс, фитнес-залы. Так что для того, чтобы взять
      спортивную высоту, тоже далеко ходить будет не&nbsp;надо.
    </Spreader>
  </StickyContainer>
);

export default MatchpointPage;
//<CallToAction />
